import script from "./cgw_bk_sk.vue?vue&type=script&setup=true&lang=js"
export * from "./cgw_bk_sk.vue?vue&type=script&setup=true&lang=js"

import "./cgw_bk_sk.vue?vue&type=style&index=0&id=07d65b21&lang=less"

const __exports__ = script;

export default __exports__